import * as React from 'react';
import {useForm} from './FormProvider';

export default function FormConditionCheck({name,value,...props}) {

    const {watch} = useForm();

    const watchedValue = watch(name);

    if (Array.isArray(value)) {
        return (
            <>
            {(value.includes(watchedValue)) && <>{props.children}</>}
            </>
        );
    } else {
        return (
            <>
            {(watchedValue === value) && <>{props.children}</>}
            </>
        );
    }

};